module.exports = __webpack_public_path__ + "static/img/5.6e2fa58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/good-fresh/fresh-images/5.jpg
// module id = fUnh
// module chunks = 1